<template>
  <div>
    <GroupList v-if="showListGroup"></GroupList>
    <GroupAdd v-if="showAddGroup"></GroupAdd>
    <GroupEdit :toEditGroup="selectedGroupId" v-if="showEditGroup"></GroupEdit>
    <GroupView :toViewGroup="selectedGroupId" v-if="showViewGroup"></GroupView>
</div>
</template>
<script>
import { BCard, BFormCheckbox, BFormGroup, BButton, BRow, BCol, BForm } from 'bootstrap-vue'
import { inject, ref, watch, provide } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import popups from '@/hooks/popups'
import store from '@/store'
import GroupList from '../groups/groups-list/GroupList.vue'
import GroupAdd from '../groups/groups-add/GroupAdd.vue'
import GroupEdit from '../groups/groups-edit/GroupEdit.vue'
import GroupView from '../groups/groups-view/GroupView.vue'

export default {
  components: { BCard, BFormGroup, BFormCheckbox, BButton, BRow, BCol, BForm, GroupList, GroupAdd, GroupEdit, GroupView},
  directives: { Ripple },
  setup(){
    const { errorToast, successToast } = popups()
    const settings = inject('settings')
    const showAddGroup = inject('showAddGroup')
    const showListGroup = inject('showListGroup')
    const showEditGroup = inject('showEditGroup')
    const showViewGroup = inject('showViewGroup')
    const selectedGroupId = inject('selectedGroupId')

    return {
      errorToast,
      successToast,
      settings,
      showAddGroup,
      showListGroup,
      showEditGroup,
      showViewGroup,
      selectedGroupId
    }
  }
}
</script>
